module.exports = __webpack_public_path__ + "static/media/play-boss-capture.89d4ac9d.png";